import { Reveal, ChapterLabel } from "./Reveal";
import { PERSPECTIVES } from "@/data";

export default function Perspectives() {
  return (
    <section id="perspectives" data-testid="perspectives-section" className="relative py-16 sm:py-24">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
        <ChapterLabel number="09" label="One Classroom" />
        <Reveal delay={0.1}>
          <h2
            data-testid="perspectives-heading"
            className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.15] tracking-tight text-[#FFFDF9]"
          >
            One classroom.
            <br />
            Three <span className="italic text-[#38BDF8]">perspectives</span>.
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-4 max-w-md text-sm text-slate-400 leading-relaxed">
            AuraXR connects the people who make learning happen.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {PERSPECTIVES.map((p, i) => (
            <Reveal key={p.role} delay={0.1 * i} className="group">
              <div data-testid={`perspective-${p.role.toLowerCase()}`} className="relative cursor-default">
                <div className="overflow-hidden rounded-2xl">
                  <img
                    src={p.img}
                    alt={`${p.role} perspective`}
                    loading="lazy"
                    className="aspect-[3/4] w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-[1.06]"
                  />
                </div>
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-[#050811]/85 via-[#050811]/10 to-transparent pointer-events-none" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="text-[10px] tracking-[0.35em] uppercase text-[#38BDF8]">{p.role}</p>
                  <p className="mt-2 font-display text-xl leading-snug text-[#FFFDF9]">{p.line}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
